import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TOrganization } from '@shared/types/organization';

export const getOrganizationById = async (
  orgId?: number
): Promise<TOrganization> => {
  return request({
    url: `organizations/${orgId}/`,
  });
};

export const useGetOrganizationById = (
  orgId?: number,
  options?: Partial<UseQueryOptions<TOrganization>>
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.getOrganizationById],
    queryFn: async () => await getOrganizationById(orgId),
    enabled: !!orgId,
    staleTime: 60000,
    ...options,
  });
};
